export const routerMonitoringQueryKeys = {
  all: ['router-monitoring'],
  routers: (filters = {}) => ['router-monitoring', 'routers', filters],
  trafficCurrent: (routerId, refreshToken = 0) => ['router-monitoring', 'traffic-current', routerId, refreshToken],
  trafficHistory: (routerId, params = {}) => ['router-monitoring', 'traffic-history', routerId, params],
  interfaces: (routerId, refresh = false) => ['router-monitoring', 'interfaces', routerId, refresh],
};

export default routerMonitoringQueryKeys;
